exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Variables\n */\n\n/**\n * Functions\n */\n\n/**\n * Mixins\n */\n.credit-card-form[data-v-2e5b8158] {\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\twidth: 100%;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tgap: 24px;\n\tgap: 1.5rem;\n}\n", ""]);

// exports
